import type { GamePresentationProfile } from "modules/common/gameRegistry";

export const SET_TABLE_COLUMN_WIDTHS = {
  icon: 5,
  name: 40,
  code: 10,
  totalSetSize: 10,
  marketCap: 15,
  type: 10,
  releaseDate: 20,
} as const;

/**
 * Keep the table grid at least as wide as its container when a game's
 * presentation hides optional columns. Fixed-layout tables otherwise leave
 * the undeclared remainder blank instead of stretching the visible cells.
 */
export function getSetTableNameColumnWidth(
  presentation: GamePresentationProfile["setTable"]
): string {
  const visibleWidth =
    SET_TABLE_COLUMN_WIDTHS.name +
    SET_TABLE_COLUMN_WIDTHS.code +
    SET_TABLE_COLUMN_WIDTHS.marketCap +
    SET_TABLE_COLUMN_WIDTHS.releaseDate +
    (presentation.showIcon ? SET_TABLE_COLUMN_WIDTHS.icon : 0) +
    (presentation.showTotalSize ? SET_TABLE_COLUMN_WIDTHS.totalSetSize : 0) +
    (presentation.showType ? SET_TABLE_COLUMN_WIDTHS.type : 0);

  return `${SET_TABLE_COLUMN_WIDTHS.name + Math.max(0, 100 - visibleWidth)}%`;
}
